import { RouterModule } from '@angular/router';
import { Component, ElementRef, OnInit, ViewEncapsulation,signal } from '@angular/core';
import { config } from '@core/interfaces/api_baseurl';
import { AuthService } from '@core/services/auth.service';

import { UserService } from '@core/auth/user/user.service';
import { CommonModule } from '@angular/common';
import { CdkDropDownModule } from '@core/customCDK/cdk-drop-down/cdk-drop-down.module';
import { GetTitleService } from '@core/services/get-title.service';
@Component({
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    CdkDropDownModule
  ],
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements OnInit {
  // currentTitle: string = '';
  pageTitle = this.titleService.currentTitle$;

  decData: any;
  count: any;
  constructor(
    public auth: AuthService,
    private elRef: ElementRef,
    private _UserService: UserService,
    private titleService: GetTitleService
  ) {

  }

  ngOnInit(): void {
    // this.titleService.currentTitle$.subscribe((title) => {
    //   this.currentTitle = title;
    // });

    this.decData = this._UserService.loginData;
    // this.getNotifications();
    this.auth.getNotificationCount();
  }

  menuadd() {
    this.elRef.nativeElement.parentElement.classList.toggle('toggled');
  }

  logout() {
    this.auth.logout(true);
    // this.toaster.openSubmitConfirmationModal('Session Expired!!');   
  }
  // getNotifications() {
    // this.auth.getNotification(config.auth.getNotification).subscribe((responce: any) => {
    //   notificationCount.set(responce.data); // Update the signal with the new count
    // })
  // }

}
